function view (path) {
  return () => import(/* webpackChunkName: '' */ '@/views/shared/' + path).then(m => m.default || m) // eslint-disable-line prefer-template
}

const SharedRoutes = [
  {
    path: '',
    name: 'shared.redirect',
    redirect: { name: 'shared.login' }
  },
  {
    path: '/sign-in',
    component: view('SignIn'),
    name: 'shared.login',
    meta: {
      layout: 'auth'
    }
  },
  {
    path: '/change-password',
    component: view('ChangePassword'),
    name: 'shared.change-password',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Account'
        },
        {
          text: 'Change Password',
          active: true
        }
      ]
    }
  },
  {
    path: '/auth/:provider/callback',
    component: view('SingleSignOn.vue'),
    name: 'shared.sso',
    meta: {
      layout: 'sso'
    }
  },
  {
    path: '/payments/:payment/view',
    component: view('PaymentRequest.vue'),
    name: 'shared.payment.viewing',
    meta: {
      layout: 'sso'
    }
  },
  {
    path: '*',
    component: view('404.vue'),
    name: 'shared.page-not-found',
    meta: {
      layout: 'auth'
    }
  }
]

export default SharedRoutes
